import { render, staticRenderFns } from "./SelectPartner.vue?vue&type=template&id=0510ab4f&scoped=true&"
import script from "./SelectPartner.vue?vue&type=script&lang=js&"
export * from "./SelectPartner.vue?vue&type=script&lang=js&"
import style0 from "./SelectPartner.vue?vue&type=style&index=0&id=0510ab4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0510ab4f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
